import { ApiException } from '@/shared/utils/api'

import type { ImportSource } from '../services/import-service-shared'

/**
 * UUID of an import source, from the source object (preferred) or from the id
 * string itself. Every source endpoint resolves it the same way, so sync, pause,
 * resume and delete can never point at different sources.
 *
 * Throws `IMPORT_SOURCE_UUID_MISSING` when neither the uuid nor the id is set.
 */
export function resolveSourceUuid(sourceOrId: ImportSource | string): string {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- '' uuid must fall back to id
  const uuid = typeof sourceOrId === 'object' ? sourceOrId.uuid || sourceOrId.id : sourceOrId

  if (!uuid) {
    throw new ApiException({
      status: 0,
      code: 'IMPORT_SOURCE_UUID_MISSING',
      message: '',
    })
  }

  return uuid
}
